<template>
    <dr-wrapper v-if="isInEditorMode" v-bind="$props" v-on="wrapOn">
        <div class="dr-text-container">
            <component :class="evaluateClasses(classes)" :is="choiseMode()">{{evaluateExpression(this.model.Text)}}</component>
        </div>
    </dr-wrapper>
    <div v-else-if="isVisible" class="dr-text-container">
            <component :class="evaluateClasses(classes)" :is="choiseMode()">{{evaluateExpression(this.model.Text)}}</component>
        </div>
</template>

<script>
import mixin from '../../mixins/base-mixin'
import inputMixin from '../../mixins/input-mixin'
import { widgetWrappersCollection } from '../../tools/widgetWrapper/widgetWrappersCollection'
import { WidgetWrapperEntity } from '../../tools/widgetWrapper/widgetsWrapperEntity.js'

export default {
  mixins: [mixin, inputMixin],
  created() {
    widgetWrappersCollection[this.model.$ID] = new WidgetWrapperEntity({
      model: this.model,
      getValue: () => this.evaluateExpression(this.model.Text)
    })
  },
  methods: {
    choiseMode() {
      switch (this.model.Mode) {
        case 'paragraph':
          return 'p'
        case 'heading1':
          return 'h1'
        case 'heading2':
          return 'h2'
        case 'heading3':
          return 'h3'
        case 'heading4':
          return 'h4'
        case 'heading5':
          return 'h5'
        case 'heading6':
          return 'h6'
        default:
          return 'span'
      }
    }
  }
}
</script>

<style>
.dr-text-container {
    min-height: 10px;
}
</style>
